import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import rightArrow from "@/assets/svg/rightArrow.svg";
import StakeArrow from "@/assets/svg/stake_arrow.svg";
import { useAccount, useContractRead } from "wagmi";
import { useContractWrite } from 'wagmi'
import { ReactSVG } from "react-svg";
import { useEffect, useMemo, useState } from "react";
import { ethers } from "ethers";
import ApproveModal from "@/components/ApproveModal/Modal";
import { arbitrumGoerli } from 'wagmi/chains'
import { jungleAbi, usdcAbi, JungleCA, USDCCA } from '@/utils/abi'
import { numberWithCommas } from '@/utils/index'
import { useToastContext } from "@/contexts/ToastContext";

export default function Stake({ handleClose, balanceObj, borrowHandler, successCb, borrowError, debt }) {
  const { address } = useAccount();
  const [num, setNum] = useState('')
  const [isOpen, setIsOpen] = useState(false);  
  const { showToast } = useToastContext();
  
  const { data:allowance } = useContractRead({
    address: USDCCA,
    abi: usdcAbi,
    functionName: 'allowance',
    args: [address, JungleCA],
    watch:true
  })

  const allowanceNum = useMemo(()=> allowance && ethers.utils.formatUnits(allowance, 18) || 0, [allowance])  
  
  const isAllowance = useMemo(() => { 
    return +num <= +allowanceNum
  }, [allowanceNum, num])
  
  const config1 = {
    mode: 'recklesslyUnprepared',
    address: USDCCA,
    abi: usdcAbi,
    functionName: 'approve',
    args: [JungleCA, ethers.constants.MaxUint256],    
  }
  
  const config2 = allowanceNum && {
    mode: 'recklesslyUnprepared',
    address: JungleCA,
    abi: jungleAbi,
    functionName: 'issueJUSD',
    args: [
      ethers.utils.parseUnits( !isNaN(num) && num || '0.0', 18)
    ],    
  } || {}
  
  const personalDebt = useMemo(() => parseFloat(Number(debt[1] || 0) ).toFixed(2), [num])  
  const personalStaked = useMemo(() => parseFloat(Number(debt[0] || 0) ).toFixed(2), [num])
  const addedDebt = useMemo(() => parseFloat(Number(debt[1] || 0) + +num).toFixed(2), [num])
  const addedStaked = useMemo(() => parseFloat(Number(debt[0] || 0) + +num).toFixed(2), [num])
  
  const { writeAsync:writeAsync1, isError:isError1 } = useContractWrite(config1)

  let { writeAsync, isError:isError2 } = useContractWrite(config2)

  const fuck = async()=>{
    try {
      const fucker = await writeAsync()
      const waitData = await fucker.wait()
      if(waitData?.status === 1){        
        showToast({
          dir:'center',
          type:'success',
          text:`${(+num).toFixed(2)} JUSD Claimed!`
        })
        successCb()
      }      
    } catch (error) {
      console.log(JSON.stringify(error));      
      if(error?.name === 'ChainMismatchError'){
        showToast({
          dir:'top',
          type:'error',
          text:`Wrong Chain`
        })
      }
      successCb()
    }
  }
  
  useEffect(() => {
    if(isError1){
      setIsOpen(false)
    }else if(isError2){
      borrowError()
    }
  }, [isError1, isError2])
  
  
  const toMax = ()=>{
    setNum(`${+balanceObj?.formatted}`)
  }
  const handleChange = (e)=>{
    let val = e.target.value    
    if(val.length > 18){
      val = val.slice(0, 18)
    }
    setNum(val)
  }

  const noBalance = useMemo(() => +balanceObj?.formatted < num, [num, balanceObj])

  const handleClick = async()=>{

    if(!num) return
    const balance = balanceObj?.formatted
    if(+num > +balance){
      return showToast({
        dir:'top',
        type:'error',
        text:`Not Enough Balance`
      })
    }
    if(!isAllowance){
      setIsOpen(true)
      try {
        const fucker = await writeAsync1()
        const waitData = await fucker.wait()
        if(waitData?.status === 1){
          setIsOpen(false)
        }      
      } catch (error) {
      }
    }else{
      fuck()
      borrowHandler(num)
    }
  }
  return (
    <>
      <Modal>
        <div className="close" onClick={handleClose}>
          <ReactSVG src={CloseImg} />          
        </div>
        <div className="content">
          <div className="title">Stake USDC</div>
          <div className="input">
            <div className="field">
              <input className="input-comp" type="number" value={num} placeholder="0.0" onChange={handleChange}/>
              <div className="r">
                <div className="max" onClick={toMax}>MAX</div>
                <div className="token">
                  {/* <div className="radius"></div> */}
                  <span>USDC</span>
                </div>
              </div>
            </div>
            <div className="balance">
              <span>${num || '0.00'}</span>
              <span>Balance: {numberWithCommas(balanceObj?.formatted)}</span>
            </div>
          </div>          
          <ReactSVG className="stake-arrow" src={StakeArrow} />
          <div className="input input2">
            <div className="field">
              <input className="input-comp" type="number" value={num} placeholder="0.0" onChange={handleChange}/>
              <div className="r">
                <div className="span-txt">Borrowing</div>
                <div className="token">                  
                  <span>JUSD</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="space-btw first-btw">
            <span>Borrowing:</span>
            <span>${num ? num : 0} JUSD</span>
          </div>
          <div className="space-btw">
            <span>Personal Total Debt:</span>
            {
              !num ? <span>${personalDebt}</span> 
              :
              <div className="line-item">
                <span>${personalDebt}</span> <ReactSVG src={rightArrow} className="right-arrow"/> <span>${personalDebt}</span>
                
              </div>
            }

          </div>
          <div className="space-btw">
            <span>Staked Value:</span>
            {
              !num ? <span>{personalStaked}</span> 
              :
              <div className="line-item">
                <span>${personalStaked}</span> <ReactSVG src={rightArrow} className="right-arrow"/> <span>${addedStaked}</span>
              </div>
            }
          </div>          
          <div onClick={handleClick} className={`stake-btn ${!num || noBalance ? 'disabled' : ''}`}>{isAllowance || !num ? 'Stake' : 'Approve'}</div>
        </div>
      </Modal>
      <ApproveModal isOpen={isOpen} handleClose={handleClose}/> 
    </>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding:29px 35px 0 35px;
  .close {
    position: absolute;
    right: 35px;
    top: 42px;
    cursor: pointer;
  }
  .stake-arrow{
    margin: 10px 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      padding-bottom:26px;
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: #32DE86;
    }
    .input {      
      height: 77px;
      padding: 11px 12px 9px 10px;
      box-sizing: border-box;
      width: 100%;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.1);
      border-radius:8px;
      .field {
      display: flex;
      justify-content: space-between;
      .radius{
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        margin-right: 2px;
      }
      .max{
        width: 62px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        border: 1px solid #32DE86;
        color: #32DE86;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 16px;
        border-radius:8px;
        margin-right: 8px;
        cursor: pointer;
      }
      .token{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
      }
      .r{
        display: flex;
      }
      
      .input-comp {
        background: transparent;
        outline: 0;
        border: 0;
        color: #fff;
        font-weight: 600;
        font-size: 23px;
        max-width: 220px;
        line-height: 24px;        
        &::placeholder{
          color: rgba(255, 255, 255, 0.6);
        }
      }      
      .r{
        display: flex;
        align-items: center;
      }
    }
    .balance{
      display: flex;
      justify-content: space-between;      
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;      
      color: rgba(255, 255, 255, 0.6);
      padding-top: 7px;
    }
    }
    .input2{
      height: 54px;  
      padding-top: 0;
      padding-bottom: 0;
      line-height: 54px;
      .span-txt{
        padding-right:14px;
        color: rgba(255, 255, 255, 0.6);
        font-weight: 400;
        font-size: 20px;
      }
    }
    .space-btw{
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: 14px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.6);
      font-weight: 400;
      line-height: 20px;
      & + .space-btw {
        margin-top: 12px;
      }
      .line-item{
        display: flex;
        align-items: center;
        .right-arrow{
          margin: 0 5px;
        }
      }
      &.first-btw{
        padding-top: 18px;
      }
    } 
    .stake-btn{
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      line-height: 44px;
      background: #32DE86;
      border-radius: 8px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      margin: 24px 0;
      cursor: pointer;
      font-size: 16px;
      margin-bottom: 32px;
      &:hover{
        background:#239B5E; 
      }
      &.disabled{
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.3);
        cursor: auto;
      }
    }
    
  }
`;